import './Contact.scss';
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { Container, Form, Row, Col, Button } from 'react-bootstrap';

function Contact({ setactivelink }) {
    const [validated, setValidated] = useState(false);
    const [phone, setPhone] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL;

    // Dynamic phone input formatting (XXXX-XXX-XXX)
    const handlePhoneChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');
        const cleanInput = input.substring(0, 10);
        
        let formatted = '';
        if (cleanInput.length <= 4) {
            formatted = cleanInput;
        } else if (cleanInput.length <= 7) {
            formatted = `${cleanInput.slice(0, 4)}-${cleanInput.slice(4)}`;
        } else {
            formatted = `${cleanInput.slice(0, 4)}-${cleanInput.slice(4, 7)}-${cleanInput.slice(7)}`;
        }
        setPhone(formatted);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        // 1. Validate Form Fields
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return;
        }

        setValidated(true);
        setIsSubmitting(true);

        // 2. Extract Data directly using form name tags
        const formData = new FormData(form);
        const templateParams = {
            from_name: formData.get('user_name'),
            from_email: formData.get('user_email'),
            phone: phone, 
            message: formData.get('user_message')
        };

        // 3. EmailJS Configurations
        // NOTE: Replace these placeholders with your actual keys from ://emailjs.com when ready
        const SERVICE_ID = 'service_3ia7ki9'; 
        const ADMIN_TEMPLATE_ID = 'template_9xjp1ih'; 
        const USER_TEMPLATE_ID = 'template_9xjp1ih';   
        const PUBLIC_KEY = 'TQZTdYSFq6DZZ0dkw';

        try {
            // Attempt to dispatch EmailJS alerts safely
            try {
                // If using default placeholder IDs, skip EmailJS to prevent 400 Bad Request template errors
                if (ADMIN_TEMPLATE_ID === 'template_9xjp1ih' || PUBLIC_KEY === 'TQZTdYSFq6DZZ0dkw') {
                    console.log('EmailJS placeholders detected. Skipping email dispatch and proceeding to database sync.');
                } else {
                    await emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, templateParams, PUBLIC_KEY);
                    await emailjs.send(SERVICE_ID, USER_TEMPLATE_ID, templateParams, PUBLIC_KEY);
                    console.log('EmailJS notifications pushed successfully.');
                }
            } catch (emailError) {
                // Log the EmailJS error but do NOT crash the execution stream so database operations continue
                console.error('EmailJS routing encountered an issue:', emailError.text || emailError);
            }

            // 4. Send form data securely to your local MySQL Database server
            const databaseResponse = await fetch(`${API_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: templateParams.from_name,
                    phone: templateParams.phone,
                    email: templateParams.from_email,
                    message: templateParams.message
                }),
            });

            if (!databaseResponse.ok) {
                throw new Error('Database server returned an operational error.');
            }

            alert('Success! Your message has been safely recorded in the local database system.');
            
            // Reset form state after successful database pipeline write
            form.reset();
            setPhone('');
            setValidated(false);
        } catch (error) {
            console.error('Submission Engine Error:', error);
            alert('Failed to complete database write. Ensure your node server.js is running.');
        } finally {
            setIsSubmitting(false);
        }
    };
    
    return (
        <Container id='contact' className="contact" onClick={() => setactivelink?.('contact')}>
            <h1 className="section-title">Contact</h1>
            <Form className='mt-5 mb-4' noValidate validated={validated} onSubmit={handleSubmit}>
                <Row>
                    <Col xs="12" md="4">
                        <Form.Group className="mb-3" controlId="contactName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" name="user_name" required />
                        </Form.Group>
                    </Col>
                    <Col xs="12" sm="6" md="4">
                        <Form.Group className="mb-3" controlId="contactMobile">
                            <Form.Label>Mobile</Form.Label>
                            <Form.Control type="text" value={phone} onChange={handlePhoneChange} />
                        </Form.Group>
                    </Col>
                    <Col xs="12" sm="6" md="4">
                        <Form.Group className="mb-3" controlId="contactEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name="user_email" required />
                        </Form.Group>
                    </Col> 
                    <Col xs="12">
                        <Form.Group className="mb-3" controlId="contactMessage">
                            <Form.Label>Message</Form.Label>
                            <Form.Control as="textarea" rows={3} name="user_message" required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='text-center'>
                        <Button variant="danger" type='submit' className='px-5' disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                        </Button>
                    </Col>
                </Row>
            </Form>        
        </Container>
    );
}

export default Contact;
